export const foundItems = {
  data: {
    result_code: "20000",
    result_message: "정상 처리되었습니다.",
    result_detail_code: null,
    result_detail_message: null,
    result_count: 29,
    result_data: [
      {
        seq: 104,
        register_date: "20240506",
        store_code: "1090",
        find_serial_number: "009",
        acpn_number: "111720240506009",
        find_date: "20240506",
        description: null,
        find_type_detail_code: "054",
        find_type_detail_name: "국민카드",
        find_feature: "나라사랑",
        find_customer_info: "조*웅",
        find_place_name: "매장바닥",
        find_time: "1638",
        empolyee_number: "154590",
        sku_to_money_yn: "N",
        sku_to_money_code: null,
        sku_to_meney_name: "",
        sku_code: null,
        sku_name: null,
        find_qty: "1",
        find_amount: "0",
        pos_number: null,
        pos_tran_number: null,
        lose_serial_number: null,
        out_customer_name: null,
        out_customer_phone_number_1: null,
        out_customer_phone_number_3: null,
        out_date: null,
        return_empolyee_number: null,
      },
      {
        seq: 126,
        register_date: "20240507",
        store_code: "1090",
        find_serial_number: "001",
        acpn_number: "111720240507001",
        find_date: "20240507",
        description: null,
        find_type_detail_code: "113",
        find_type_detail_name: "우산",
        find_feature: "검은장우산",
        find_customer_info: null,
        find_place_name: "셀프3층",
        find_time: "0950",
        empolyee_number: "092879",
        sku_to_money_yn: "N",
        sku_to_money_code: null,
        sku_to_meney_name: "",
        sku_code: null,
        sku_name: null,
        find_qty: "1",
        find_amount: "0",
        pos_number: null,
        pos_tran_number: null,
        lose_serial_number: null,
        out_customer_name: null,
        out_customer_phone_number_1: null,
        out_customer_phone_number_3: null,
        out_date: null,
        return_empolyee_number: null,
      },
      {
        seq: 100,
        register_date: "20240506",
        store_code: "1090",
        find_serial_number: "005",
        acpn_number: "111720240506005",
        find_date: "20240506",
        description: null,
        find_type_detail_code: "141",
        find_type_detail_name: "매장판매상품",
        find_feature: "2건",
        find_customer_info: null,
        find_place_name: "셀프4(더편한팬츠,포켓몬볼캡)",
        find_time: "1535",
        empolyee_number: "083492",
        sku_to_money_yn: "Y",
        sku_to_money_code: "02",
        sku_to_meney_name: "상품",
        sku_code: "2220030384026",
        sku_name: "DK더편한팬츠",
        find_qty: "2",
        find_amount: "23160",
        pos_number: "2027",
        pos_tran_number: "4744",
        lose_serial_number: null,
        out_customer_name: null,
        out_customer_phone_number_1: null,
        out_customer_phone_number_3: null,
        out_date: null,
        return_empolyee_number: null,
      },
      {
        seq: 29,
        register_date: "20240507",
        store_code: "1090",
        find_serial_number: "001",
        acpn_number: "111720240507001",
        find_date: "20240507",
        description: null,
        find_type_detail_code: "113",
        find_type_detail_name: "우산",
        find_feature: "검은장우산",
        find_customer_info: null,
        find_place_name: "셀프3층",
        find_time: "0950",
        empolyee_number: "092879",
        sku_to_money_yn: "N",
        sku_to_money_code: null,
        sku_to_meney_name: "",
        sku_code: null,
        sku_name: null,
        find_qty: "1",
        find_amount: "0",
        pos_number: null,
        pos_tran_number: null,
        lose_serial_number: null,
        out_customer_name: null,
        out_customer_phone_number_1: null,
        out_customer_phone_number_3: null,
        out_date: null,
        return_empolyee_number: null,
      },
      {
        seq: 17,
        register_date: "20240506",
        store_code: "1090",
        find_serial_number: "001",
        acpn_number: "111720240506001",
        find_date: "20240506",
        description: null,
        find_type_detail_code: "113",
        find_type_detail_name: "우산",
        find_feature: "와인색2단",
        find_customer_info: null,
        find_place_name: "pos",
        find_time: "1202",
        empolyee_number: "154590",
        sku_to_money_yn: "N",
        sku_to_money_code: null,
        sku_to_meney_name: "",
        sku_code: null,
        sku_name: null,
        find_qty: "1",
        find_amount: "0",
        pos_number: null,
        pos_tran_number: null,
        lose_serial_number: null,
        out_customer_name: null,
        out_customer_phone_number_1: null,
        out_customer_phone_number_3: null,
        out_date: null,
        return_empolyee_number: null,
      },
      {
        seq: 18,
        register_date: "20240506",
        store_code: "1090",
        find_serial_number: "002",
        acpn_number: "111720240506002",
        find_date: "20240506",
        description: null,
        find_type_detail_code: "113",
        find_type_detail_name: "우산",
        find_feature: "검정장우산",
        find_customer_info: null,
        find_place_name: "pos",
        find_time: "1435",
        empolyee_number: "083522",
        sku_to_money_yn: "N",
        sku_to_money_code: null,
        sku_to_meney_name: "",
        sku_code: null,
        sku_name: null,
        find_qty: "1",
        find_amount: "0",
        pos_number: null,
        pos_tran_number: null,
        lose_serial_number: null,
        out_customer_name: null,
        out_customer_phone_number_1: null,
        out_customer_phone_number_3: null,
        out_date: null,
        return_empolyee_number: null,
      },
      {
        seq: 19,
        register_date: "20240506",
        store_code: "1090",
        find_serial_number: "003",
        acpn_number: "111720240506003",
        find_date: "20240506",
        description: null,
        find_type_detail_code: "113",
        find_type_detail_name: "우산",
        find_feature: "검정장우산",
        find_customer_info: null,
        find_place_name: "2층카트",
        find_time: "1510",
        empolyee_number: "083492",
        sku_to_money_yn: "N",
        sku_to_money_code: null,
        sku_to_meney_name: "",
        sku_code: null,
        sku_name: null,
        find_qty: "1",
        find_amount: "0",
        pos_number: null,
        pos_tran_number: null,
        lose_serial_number: null,
        out_customer_name: null,
        out_customer_phone_number_1: null,
        out_customer_phone_number_3: null,
        out_date: null,
        return_empolyee_number: null,
      },
      {
        seq: 20,
        register_date: "20240506",
        store_code: "1090",
        find_serial_number: "004",
        acpn_number: "111720240506004",
        find_date: "20240506",
        description: null,
        find_type_detail_code: "113",
        find_type_detail_name: "우산",
        find_feature: null,
        find_customer_info: null,
        find_place_name: "휠체어",
        find_time: "1515",
        empolyee_number: "083492",
        sku_to_money_yn: "N",
        sku_to_money_code: null,
        sku_to_meney_name: "",
        sku_code: null,
        sku_name: null,
        find_qty: "1",
        find_amount: "0",
        pos_number: null,
        pos_tran_number: null,
        lose_serial_number: null,
        out_customer_name: null,
        out_customer_phone_number_1: null,
        out_customer_phone_number_3: null,
        out_date: null,
        return_empolyee_number: null,
      },
      {
        seq: 21,
        register_date: "20240506",
        store_code: "1090",
        find_serial_number: "012",
        acpn_number: "111720240506012",
        find_date: "20240506",
        description: null,
        find_type_detail_code: "113",
        find_type_detail_name: "우산",
        find_feature: "키티장우산",
        find_customer_info: null,
        find_place_name: "2층바구니",
        find_time: "1658",
        empolyee_number: "083086",
        sku_to_money_yn: "N",
        sku_to_money_code: null,
        sku_to_meney_name: "",
        sku_code: null,
        sku_name: null,
        find_qty: "1",
        find_amount: "0",
        pos_number: null,
        pos_tran_number: null,
        lose_serial_number: null,
        out_customer_name: null,
        out_customer_phone_number_1: null,
        out_customer_phone_number_3: null,
        out_date: null,
        return_empolyee_number: null,
      },
      {
        seq: 22,
        register_date: "20240506",
        store_code: "1090",
        find_serial_number: "013",
        acpn_number: "111720240506013",
        find_date: "20240506",
        description: null,
        find_type_detail_code: "113",
        find_type_detail_name: "우산",
        find_feature: "비닐MLA",
        find_customer_info: null,
        find_place_name: "센타앞",
        find_time: "1827",
        empolyee_number: "083121",
        sku_to_money_yn: "N",
        sku_to_money_code: null,
        sku_to_meney_name: "",
        sku_code: null,
        sku_name: null,
        find_qty: "1",
        find_amount: "0",
        pos_number: null,
        pos_tran_number: null,
        lose_serial_number: null,
        out_customer_name: null,
        out_customer_phone_number_1: "010",
        out_customer_phone_number_3: "5496",
        out_date: "20240506",
        return_empolyee_number: "083121",
      },
      {
        seq: 23,
        register_date: "20240506",
        store_code: "1090",
        find_serial_number: "014",
        acpn_number: "111720240506014",
        find_date: "20240506",
        description: null,
        find_type_detail_code: "113",
        find_type_detail_name: "우산",
        find_feature: "검정색자동",
        find_customer_info: null,
        find_place_name: "카트(접이식)",
        find_time: "1829",
        empolyee_number: "105795",
        sku_to_money_yn: "N",
        sku_to_money_code: null,
        sku_to_meney_name: "",
        sku_code: null,
        sku_name: null,
        find_qty: "1",
        find_amount: "0",
        pos_number: null,
        pos_tran_number: null,
        lose_serial_number: null,
        out_customer_name: null,
        out_customer_phone_number_1: null,
        out_customer_phone_number_3: null,
        out_date: null,
        return_empolyee_number: null,
      },
      {
        seq: 24,
        register_date: "20240506",
        store_code: "1090",
        find_serial_number: "016",
        acpn_number: "111720240506016",
        find_date: "20240506",
        description: null,
        find_type_detail_code: "113",
        find_type_detail_name: "우산",
        find_feature: "GS검정비닐",
        find_customer_info: null,
        find_place_name: "셀프",
        find_time: "1830",
        empolyee_number: "105795",
        sku_to_money_yn: "N",
        sku_to_money_code: null,
        sku_to_meney_name: "",
        sku_code: null,
        sku_name: null,
        find_qty: "1",
        find_amount: "0",
        pos_number: null,
        pos_tran_number: null,
        lose_serial_number: null,
        out_customer_name: null,
        out_customer_phone_number_1: null,
        out_customer_phone_number_3: null,
        out_date: null,
        return_empolyee_number: null,
      },
      {
        seq: 25,
        register_date: "20240506",
        store_code: "1090",
        find_serial_number: "017",
        acpn_number: "111720240506017",
        find_date: "20240506",
        description: null,
        find_type_detail_code: "113",
        find_type_detail_name: "우산",
        find_feature: "베이지 장",
        find_customer_info: null,
        find_place_name: "셀프",
        find_time: "1830",
        empolyee_number: "083121",
        sku_to_money_yn: "N",
        sku_to_money_code: null,
        sku_to_meney_name: "",
        sku_code: null,
        sku_name: null,
        find_qty: "1",
        find_amount: "0",
        pos_number: null,
        pos_tran_number: null,
        lose_serial_number: null,
        out_customer_name: null,
        out_customer_phone_number_1: null,
        out_customer_phone_number_3: null,
        out_date: null,
        return_empolyee_number: null,
      },
      {
        seq: 26,
        register_date: "20240506",
        store_code: "1090",
        find_serial_number: "025",
        acpn_number: "111720240506025",
        find_date: "20240506",
        description: null,
        find_type_detail_code: "113",
        find_type_detail_name: "우산",
        find_feature: "투명장우산",
        find_customer_info: null,
        find_place_name: "셀프",
        find_time: "2017",
        empolyee_number: "156432",
        sku_to_money_yn: "N",
        sku_to_money_code: null,
        sku_to_meney_name: "",
        sku_code: null,
        sku_name: null,
        find_qty: "1",
        find_amount: "0",
        pos_number: null,
        pos_tran_number: null,
        lose_serial_number: null,
        out_customer_name: null,
        out_customer_phone_number_1: null,
        out_customer_phone_number_3: null,
        out_date: null,
        return_empolyee_number: null,
      },
      {
        seq: 27,
        register_date: "20240506",
        store_code: "1090",
        find_serial_number: "026",
        acpn_number: "111720240506026",
        find_date: "20240506",
        description: null,
        find_type_detail_code: "113",
        find_type_detail_name: "우산",
        find_feature: "네이비접이",
        find_customer_info: null,
        find_place_name: "2층 카트",
        find_time: "2048",
        empolyee_number: "156432",
        sku_to_money_yn: "N",
        sku_to_money_code: null,
        sku_to_meney_name: "",
        sku_code: null,
        sku_name: null,
        find_qty: "1",
        find_amount: "0",
        pos_number: null,
        pos_tran_number: null,
        lose_serial_number: null,
        out_customer_name: null,
        out_customer_phone_number_1: "010",
        out_customer_phone_number_3: "2937",
        out_date: "20240506",
        return_empolyee_number: "156432",
      },
      {
        seq: 28,
        register_date: "20240506",
        store_code: "1090",
        find_serial_number: "030",
        acpn_number: "111720240506030",
        find_date: "20240506",
        description: null,
        find_type_detail_code: "113",
        find_type_detail_name: "우산",
        find_feature: "흰색동물장",
        find_customer_info: null,
        find_place_name: "셀프",
        find_time: "2219",
        empolyee_number: "156432",
        sku_to_money_yn: "N",
        sku_to_money_code: null,
        sku_to_meney_name: "",
        sku_code: null,
        sku_name: null,
        find_qty: "1",
        find_amount: "0",
        pos_number: null,
        pos_tran_number: null,
        lose_serial_number: null,
        out_customer_name: null,
        out_customer_phone_number_1: null,
        out_customer_phone_number_3: null,
        out_date: null,
        return_empolyee_number: null,
      },
      {
        seq: 5,
        register_date: "20240505",
        store_code: "1090",
        find_serial_number: "008",
        acpn_number: "111720240505008",
        find_date: "20240505",
        description: null,
        find_type_detail_code: "113",
        find_type_detail_name: "우산",
        find_feature: "검정장우산",
        find_customer_info: null,
        find_place_name: "계산대(프릴모양)",
        find_time: "1550",
        empolyee_number: "083492",
        sku_to_money_yn: "N",
        sku_to_money_code: null,
        sku_to_meney_name: "",
        sku_code: null,
        sku_name: null,
        find_qty: "1",
        find_amount: "0",
        pos_number: null,
        pos_tran_number: null,
        lose_serial_number: null,
        out_customer_name: null,
        out_customer_phone_number_1: null,
        out_customer_phone_number_3: null,
        out_date: null,
        return_empolyee_number: null,
      },
      {
        seq: 6,
        register_date: "20240505",
        store_code: "1090",
        find_serial_number: "009",
        acpn_number: "111720240505009",
        find_date: "20240505",
        description: null,
        find_type_detail_code: "113",
        find_type_detail_name: "우산",
        find_feature: "곤색장우산",
        find_customer_info: null,
        find_place_name: "계산대",
        find_time: "1550",
        empolyee_number: "083492",
        sku_to_money_yn: "N",
        sku_to_money_code: null,
        sku_to_meney_name: "",
        sku_code: null,
        sku_name: null,
        find_qty: "1",
        find_amount: "0",
        pos_number: null,
        pos_tran_number: null,
        lose_serial_number: null,
        out_customer_name: null,
        out_customer_phone_number_1: null,
        out_customer_phone_number_3: null,
        out_date: null,
        return_empolyee_number: null,
      },
      {
        seq: 7,
        register_date: "20240505",
        store_code: "1090",
        find_serial_number: "013",
        acpn_number: "111720240505013",
        find_date: "20240505",
        description: null,
        find_type_detail_code: "113",
        find_type_detail_name: "우산",
        find_feature: "하트무늬장",
        find_customer_info: null,
        find_place_name: "3층셀프",
        find_time: "1704",
        empolyee_number: "154590",
        sku_to_money_yn: "N",
        sku_to_money_code: null,
        sku_to_meney_name: "",
        sku_code: null,
        sku_name: null,
        find_qty: "1",
        find_amount: "0",
        pos_number: null,
        pos_tran_number: null,
        lose_serial_number: null,
        out_customer_name: null,
        out_customer_phone_number_1: null,
        out_customer_phone_number_3: null,
        out_date: null,
        return_empolyee_number: null,
      },
      {
        seq: 8,
        register_date: "20240505",
        store_code: "1090",
        find_serial_number: "015",
        acpn_number: "111720240505015",
        find_date: "20240505",
        description: null,
        find_type_detail_code: "113",
        find_type_detail_name: "우산",
        find_feature: "체크3단",
        find_customer_info: null,
        find_place_name: "매장",
        find_time: "1754",
        empolyee_number: "083522",
        sku_to_money_yn: "N",
        sku_to_money_code: null,
        sku_to_meney_name: "",
        sku_code: null,
        sku_name: null,
        find_qty: "1",
        find_amount: "0",
        pos_number: null,
        pos_tran_number: null,
        lose_serial_number: null,
        out_customer_name: null,
        out_customer_phone_number_1: null,
        out_customer_phone_number_3: null,
        out_date: null,
        return_empolyee_number: null,
      },
      {
        seq: 9,
        register_date: "20240505",
        store_code: "1090",
        find_serial_number: "016",
        acpn_number: "111720240505016",
        find_date: "20240505",
        description: null,
        find_type_detail_code: "113",
        find_type_detail_name: "우산",
        find_feature: "딸기모자",
        find_customer_info: null,
        find_place_name: "매장",
        find_time: "1801",
        empolyee_number: "083522",
        sku_to_money_yn: "N",
        sku_to_money_code: null,
        sku_to_meney_name: "",
        sku_code: null,
        sku_name: null,
        find_qty: "1",
        find_amount: "0",
        pos_number: null,
        pos_tran_number: null,
        lose_serial_number: null,
        out_customer_name: null,
        out_customer_phone_number_1: null,
        out_customer_phone_number_3: null,
        out_date: null,
        return_empolyee_number: null,
      },
      {
        seq: 10,
        register_date: "20240505",
        store_code: "1090",
        find_serial_number: "017",
        acpn_number: "111720240505017",
        find_date: "20240505",
        description: null,
        find_type_detail_code: "113",
        find_type_detail_name: "우산",
        find_feature: "검정3단",
        find_customer_info: null,
        find_place_name: "매장",
        find_time: "1800",
        empolyee_number: "083522",
        sku_to_money_yn: "N",
        sku_to_money_code: null,
        sku_to_meney_name: "",
        sku_code: null,
        sku_name: null,
        find_qty: "1",
        find_amount: "0",
        pos_number: null,
        pos_tran_number: null,
        lose_serial_number: null,
        out_customer_name: null,
        out_customer_phone_number_1: null,
        out_customer_phone_number_3: null,
        out_date: null,
        return_empolyee_number: null,
      },
      {
        seq: 11,
        register_date: "20240505",
        store_code: "1090",
        find_serial_number: "021",
        acpn_number: "111720240505021",
        find_date: "20240505",
        description: null,
        find_type_detail_code: "113",
        find_type_detail_name: "우산",
        find_feature: "투명우산",
        find_customer_info: null,
        find_place_name: "pos",
        find_time: "1928",
        empolyee_number: "083522",
        sku_to_money_yn: "N",
        sku_to_money_code: null,
        sku_to_meney_name: "",
        sku_code: null,
        sku_name: null,
        find_qty: "1",
        find_amount: "0",
        pos_number: null,
        pos_tran_number: null,
        lose_serial_number: null,
        out_customer_name: null,
        out_customer_phone_number_1: null,
        out_customer_phone_number_3: null,
        out_date: null,
        return_empolyee_number: null,
      },
      {
        seq: 12,
        register_date: "20240505",
        store_code: "1090",
        find_serial_number: "024",
        acpn_number: "111720240505024",
        find_date: "20240505",
        description: null,
        find_type_detail_code: "113",
        find_type_detail_name: "우산",
        find_feature: "투명장우산",
        find_customer_info: null,
        find_place_name: "3층 ATM기",
        find_time: "2134",
        empolyee_number: "156432",
        sku_to_money_yn: "N",
        sku_to_money_code: null,
        sku_to_meney_name: "",
        sku_code: null,
        sku_name: null,
        find_qty: "1",
        find_amount: "0",
        pos_number: null,
        pos_tran_number: null,
        lose_serial_number: null,
        out_customer_name: null,
        out_customer_phone_number_1: null,
        out_customer_phone_number_3: null,
        out_date: null,
        return_empolyee_number: null,
      },
      {
        seq: 13,
        register_date: "20240505",
        store_code: "1090",
        find_serial_number: "025",
        acpn_number: "111720240505025",
        find_date: "20240505",
        description: null,
        find_type_detail_code: "113",
        find_type_detail_name: "우산",
        find_feature: "2단자동",
        find_customer_info: null,
        find_place_name: "3층 ATM기",
        find_time: "2134",
        empolyee_number: "156432",
        sku_to_money_yn: "N",
        sku_to_money_code: null,
        sku_to_meney_name: "",
        sku_code: null,
        sku_name: null,
        find_qty: "1",
        find_amount: "0",
        pos_number: null,
        pos_tran_number: null,
        lose_serial_number: null,
        out_customer_name: null,
        out_customer_phone_number_1: null,
        out_customer_phone_number_3: null,
        out_date: null,
        return_empolyee_number: null,
      },
      {
        seq: 14,
        register_date: "20240505",
        store_code: "1090",
        find_serial_number: "026",
        acpn_number: "111720240505026",
        find_date: "20240505",
        description: null,
        find_type_detail_code: "113",
        find_type_detail_name: "우산",
        find_feature: "검정장우산",
        find_customer_info: null,
        find_place_name: "3층ATM기",
        find_time: "2135",
        empolyee_number: "156432",
        sku_to_money_yn: "N",
        sku_to_money_code: null,
        sku_to_meney_name: "",
        sku_code: null,
        sku_name: null,
        find_qty: "1",
        find_amount: "0",
        pos_number: null,
        pos_tran_number: null,
        lose_serial_number: null,
        out_customer_name: null,
        out_customer_phone_number_1: null,
        out_customer_phone_number_3: null,
        out_date: null,
        return_empolyee_number: null,
      },
      {
        seq: 15,
        register_date: "20240505",
        store_code: "1090",
        find_serial_number: "027",
        acpn_number: "111720240505027",
        find_date: "20240505",
        description: null,
        find_type_detail_code: "113",
        find_type_detail_name: "우산",
        find_feature: "검정장우산",
        find_customer_info: null,
        find_place_name: "3층 ATM기",
        find_time: "2135",
        empolyee_number: "156432",
        sku_to_money_yn: "N",
        sku_to_money_code: null,
        sku_to_meney_name: "",
        sku_code: null,
        sku_name: null,
        find_qty: "1",
        find_amount: "0",
        pos_number: null,
        pos_tran_number: null,
        lose_serial_number: null,
        out_customer_name: null,
        out_customer_phone_number_1: null,
        out_customer_phone_number_3: null,
        out_date: null,
        return_empolyee_number: null,
      },
      {
        seq: 16,
        register_date: "20240505",
        store_code: "1090",
        find_serial_number: "028",
        acpn_number: "111720240505028",
        find_date: "20240505",
        description: null,
        find_type_detail_code: "113",
        find_type_detail_name: "우산",
        find_feature: "투명장우산",
        find_customer_info: null,
        find_place_name: "4번 pos",
        find_time: "2203",
        empolyee_number: "156432",
        sku_to_money_yn: "N",
        sku_to_money_code: null,
        sku_to_meney_name: "",
        sku_code: null,
        sku_name: null,
        find_qty: "1",
        find_amount: "0",
        pos_number: null,
        pos_tran_number: null,
        lose_serial_number: null,
        out_customer_name: null,
        out_customer_phone_number_1: null,
        out_customer_phone_number_3: null,
        out_date: null,
        return_empolyee_number: null,
      },
      {
        seq: 1,
        register_date: "20240502",
        store_code: "1090",
        find_serial_number: "002",
        acpn_number: "111720240502002",
        find_date: "20240502",
        description: null,
        find_type_detail_code: "113",
        find_type_detail_name: "우산",
        find_feature: "네이비",
        find_customer_info: null,
        find_place_name: "셀프",
        find_time: "1020",
        empolyee_number: "083121",
        sku_to_money_yn: "N",
        sku_to_money_code: null,
        sku_to_meney_name: "",
        sku_code: null,
        sku_name: null,
        find_qty: "1",
        find_amount: "0",
        pos_number: null,
        pos_tran_number: null,
        lose_serial_number: null,
        out_customer_name: null,
        out_customer_phone_number_1: null,
        out_customer_phone_number_3: null,
        out_date: null,
        return_empolyee_number: null,
      },
      {
        seq: 2,
        register_date: "20240502",
        store_code: "1090",
        find_serial_number: "003",
        acpn_number: "111720240502003",
        find_date: "20240502",
        description: null,
        find_type_detail_code: "113",
        find_type_detail_name: "우산",
        find_feature: "무지개장우",
        find_customer_info: null,
        find_place_name: "셀프",
        find_time: "1020",
        empolyee_number: "083121",
        sku_to_money_yn: "N",
        sku_to_money_code: null,
        sku_to_meney_name: "",
        sku_code: null,
        sku_name: null,
        find_qty: "1",
        find_amount: "0",
        pos_number: null,
        pos_tran_number: null,
        lose_serial_number: null,
        out_customer_name: null,
        out_customer_phone_number_1: null,
        out_customer_phone_number_3: null,
        out_date: null,
        return_empolyee_number: null,
      },
      {
        seq: 3,
        register_date: "20240502",
        store_code: "1090",
        find_serial_number: "004",
        acpn_number: "111720240502004",
        find_date: "20240502",
        description: null,
        find_type_detail_code: "113",
        find_type_detail_name: "우산",
        find_feature: "검정색장",
        find_customer_info: null,
        find_place_name: "셀프",
        find_time: "1020",
        empolyee_number: "083121",
        sku_to_money_yn: "N",
        sku_to_money_code: null,
        sku_to_meney_name: "",
        sku_code: null,
        sku_name: null,
        find_qty: "1",
        find_amount: "0",
        pos_number: null,
        pos_tran_number: null,
        lose_serial_number: null,
        out_customer_name: null,
        out_customer_phone_number_1: null,
        out_customer_phone_number_3: null,
        out_date: null,
        return_empolyee_number: null,
      },
      {
        seq: 4,
        register_date: "20240502",
        store_code: "1090",
        find_serial_number: "005",
        acpn_number: "111720240502005",
        find_date: "20240502",
        description: null,
        find_type_detail_code: "113",
        find_type_detail_name: "우산",
        find_feature: "키스허니",
        find_customer_info: "비*장우산",
        find_place_name: "셀프",
        find_time: "1020",
        empolyee_number: "083121",
        sku_to_money_yn: "N",
        sku_to_money_code: null,
        sku_to_meney_name: "",
        sku_code: null,
        sku_name: null,
        find_qty: "1",
        find_amount: "0",
        pos_number: null,
        pos_tran_number: null,
        lose_serial_number: null,
        out_customer_name: null,
        out_customer_phone_number_1: null,
        out_customer_phone_number_3: null,
        out_date: null,
        return_empolyee_number: null,
      },
    ],
  },
};
